module.exports = __webpack_public_path__ + "static/trust_world_icon-5811493f92aae208415942eed790cec4.png";